const kBytesPerMegabyte = 1024 * 1024;

export const bytesToMB = (bytes: number): number => bytes / kBytesPerMegabyte;

export const bytesToDisplayMB = (bytes: number, fixed = 2): string =>
    `${bytesToMB(bytes).toFixed(fixed)}MB`;
